import { call, put, select, takeLatest } from 'redux-saga/effects'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { ITimelineState } from '../store/timeline.types'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'

export function* setParentVitalsPtaStatus() {
  const { selectedItem, items: timelineItems }: ITimelineState = yield select(getPatientTimelineSelector)
  const { ptaToSync }: ITimelineState = yield select(getPatientTimelineSelector)
  const serviceId: string = yield select(getServiceIdSelector)

  if (!selectedItem?.clientEventId) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrID: string = yield select(getPcrIdSelector)

    if (pcrID) {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

      // Update the parent vitals timeline item
      if (!timelineItems) return

      const parentVitalsTimelineIndex = timelineItems.findIndex((item) => {
        return item.clientEventId === selectedItem.clientEventId && item.itemType === 'Vitals'
      })
      if (parentVitalsTimelineIndex === -1) return

      const parentVitalsTimelineItem = timelineItems[parentVitalsTimelineIndex]
      timelineItems[parentVitalsTimelineIndex] = {
        ...parentVitalsTimelineItem,
        labelHeaderFlag: ptaToSync ? 'PTA' : undefined,
      }

      // Update the parent vitals full object
      const patientVitals = pcrDoc.patient.patientVitals
      if (!patientVitals) return

      const parentVitalsIndex = patientVitals.findIndex((vitals) => {
        return vitals.clientEventId?.toString() === selectedItem.clientEventId
      })
      if (parentVitalsIndex === -1) return

      const parentVitals = patientVitals[parentVitalsIndex]
      patientVitals[parentVitalsIndex] = {
        ...parentVitals,
        pta: ptaToSync,
      }

      const updatedPatient = {
        ...pcrDoc.patient,
        patientVitals: patientVitals,
        timelineItems: timelineItems,
      }

      const pcrDocUpdated = { ...pcrDoc, patient: updatedPatient }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setActivityLog(timelineItems))
    }
  } catch (e) {
    yield put(throwPcrException(`setParentVitalsPtaStatus() error: ${e}`))
  }
}

export function* setParentVitalsPtaStatusSaga() {
  yield takeLatest([TimelineConstants.SYNC_PTA_WITH_PARENT_VITALS], performWithMutexHOG, setParentVitalsPtaStatus)
}
